<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Imagen Sección Principal
              <small>(portada):</small>
            </h3>
          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!cover_image_main_section"
              v-model="cover_image_main_section"
              @change="onProjectImageChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen portada"
              :messages="['Para una mejor visualización, usar un imagen cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="cover_image_main_section"
              wei>
              <v-img
                contain
                :src="url_cover_image_main_section"
                class="grey lighten-2"
                height="440px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteProjectImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>

          <v-divider></v-divider>
          
          <v-col cols="12" class="pt-8 mb-4">
            <h4>Imangen Principal:</h4>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-row>
              <v-col cols="12">
                <v-slider
                  v-model="shade_image_main_section"
                  label="Sombra"
                  thumb-color="black"
                  thumb-label="always"
                  max="1"
                  min="0"
                  step="0.01"
                ></v-slider>
              </v-col>
            </v-row> 
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-row>
              <v-col cols="12">
                <v-slider
                  v-model="blur_image_main_section"
                  label="Blur"
                  thumb-color="red"
                  thumb-label="always"
                  max="8"
                  min="0"
                  step="1"
                ></v-slider>
              </v-col>
            </v-row> 
          </v-col>
        </v-row>

      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Slogan/frase corta
            </h3>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="slogan_main_section"
              :counter="100"
              outlined
              label="Slogan"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_update"
        color="primary"
        :to="{ name: 'customizationLanding' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationMainSection()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationMyProject',
    data: () => ({
      loading:true,
      loading_update: false,
      landing:[],

      cover_image_main_section: null,
      url_cover_image_main_section: null,

      shade_image_main_section:0.2,
      blur_image_main_section:3,

      slogan_main_section: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/landing').then(response =>{
          this.landing = response.data.data.landing

          this.cover_image_main_section = response.data.data.landing.cover_image_main_section
          this.url_cover_image_main_section = APP_URL+ this.cover_image_main_section

          this.slogan_main_section = (response.data.data.landing.slogan_main_section!=null)?response.data.data.landing.slogan_main_section:''
          this.shade_image_main_section = response.data.data.landing.shade_image_main_section
          this.blur_image_main_section = response.data.data.landing.blur_image_main_section

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationMainSection(){
        this.loading_update=true
        
        let formData= new FormData()
        formData.append('cover_image_main_section', this.cover_image_main_section)
        formData.append('slogan_main_section', this.slogan_main_section)
        formData.append('shade_image_main_section', this.shade_image_main_section)
        formData.append('blur_image_main_section', this.blur_image_main_section)

        try {
          await axios({
            method: 'post',
            url: 'admin/landing/main-section',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationLanding' })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
          this.loading_update=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      },

      //-------My Project-----------
      onProjectImageChange() {
        this.url_cover_image_main_section = URL.createObjectURL(this.cover_image_main_section);
      },

      deleteProjectImage(){
        this.cover_image_main_section=null
        this.url_cover_image_main_section=null
      }
    },

    created(){
      this.getCustomization()
    },
  }
</script>
